<template>
    <div class="llp-spinner row p-0">
        <div v-if="showLoading" :class="classNames">
            <div :style="styleLoading" class="spinner-border text-primary"
                 role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'BaseSpinner',
  data: function() {
    return {};
  },
  props: {
    showLoading: {
      type: Boolean,
      required: true,
    },
    styleLoading: {
      type: String,
      required: false,
      default: 'width: 6rem; height: 6rem;',
    },
    classNames: {
      type: String,
      required: false,
      default: 'd-flex justify-content-center py-4',
    },
  },
  methods: {},
};
</script>
